import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "translateLanguages": []
}
const translateLanguageData = createSlice({
    name:'translateLanguageData',
    initialState,
    reducers:{
        translateLanguage: (_state,payload)=>{
            return {
                ..._state,
                "id" : uuidv4(),
                "translateLanguages": payload.payload
            }
        }
    }
});

export default translateLanguageData.reducer
export const translateLanguage = translateLanguageData.actions.translateLanguage